import { graphql, useStaticQuery } from 'gatsby';

type AllCategories = {
	categories: {
		distinct: string[];
	};
};

export const useAllCategories = (): string[] => {
	const {
		categories: { distinct: categories },
	}: AllCategories = useStaticQuery(graphql`
		query {
			categories: allMdx(filter: { frontmatter: { type: { eq: "post" } } }) {
				distinct(field: { frontmatter: { category: SELECT } })
			}
		}
	`);

	return categories;
};
